import { APP_BOOTSTRAP_LISTENER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { jwtInterceptor } from './core/helpers/jwt.interceptor';
import { errorInterceptor } from './core/helpers/error.interceptor';
import { NgxPermissionsModule } from 'ngx-permissions';
import { OverlayContainer } from '@angular/cdk/overlay';
import { FormsModule } from '@angular/forms';
import { HighchartsChartModule } from 'highcharts-angular';
import { MaterialModule } from './shared/modules/material.module';
import { AppStartupService } from './core/helpers/app-startup.service';
import { SKELETON_LOADERS } from './shared/components/skeleton-loaders';


@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgxPermissionsModule.forRoot(),
    NgbModule,
    BrowserAnimationsModule,
    MaterialModule,
    FormsModule,
    HighchartsChartModule,
    ...SKELETON_LOADERS,
  ],
  providers: [
    BrowserAnimationsModule,
    provideHttpClient(withInterceptors([jwtInterceptor, errorInterceptor])),
    {
      // Runs after the root component is rendered; does not block bootstrap (unlike APP_INITIALIZER).
      provide: APP_BOOTSTRAP_LISTENER,
      useFactory: (startup: AppStartupService) => () => startup.preloadPermissions(),
      deps: [AppStartupService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(overlayContainer: OverlayContainer) {
    overlayContainer.getContainerElement().classList.add('light');
  }
}
